import { FC } from 'react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { PageInfoHeaderSkeleton } from '@whitesharx/starfall-frontend-core';
import { ExercisesProgressSkeleton } from '@whitesharx/starfall-frontend-core/learn_screen';

import { UserInfoSkeleton } from '~/src/components/UserInfo/UserInfoSkeleton';
import { PageLayoutSkeleton } from '~/src/components/PageLayout/PageLayoutSkeleton';
import { InfoHeaderSkeleton } from '~/src/components/InfoHeader/InfoHeaderSkeleton';
import { pageTitleBlurStyles } from '~/styles/pages/common.css';

const LessonsSkeletonPage: FC = () => (
  <PageLayoutSkeleton rightContainer={<UserInfoSkeleton />}>
    <InfoHeaderSkeleton />
    <PageInfoHeaderSkeleton title={t('learn.lessons.page-title')} name="lesson" textClassName={pageTitleBlurStyles} />
    <ExercisesProgressSkeleton withCompleted />
  </PageLayoutSkeleton>
);

export default LessonsSkeletonPage;
